/* eslint-disable no-param-reassign, no-plusplus */
export default function slugifyText(str, useDash) {
	str = str.replace(/^\s+|\s+$/g, ''); // trim
	str = str.toLowerCase();

	// remove accents, swap ñ for n, etc
	const from = 'åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;';
	const to = 'aaaaaaeeeeiiiioooouuuunc------';

	for (let i = 0, l = from.length; i < l; i++) {
		str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
	}

	str = str
		.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
		.replace(/\s+/g, useDash ? '-' : '_') // collapse whitespace and replace by -
		.replace(/-+/g, useDash ? '-' : '_') // collapse dashes
		.replace(/^[0-9]*/, '') // remove any starting numbers
		.replace(/^-+/, '') // trim - from start of text
		.replace(/-+$/, ''); // trim - from end of text

	return str;
}
